import {
  InfoApi as InfoApiGen,
  LogoutApi as LogoutApiGen,
  PingApi as PingApiGen,
  PreApi as PreApiGen,
} from './gen/auth'
import { AuthApiConfiguration } from './config'

export const InfoApi = new InfoApiGen(AuthApiConfiguration)
export const LogoutApi = new LogoutApiGen(AuthApiConfiguration)
export const PingApi = new PingApiGen(AuthApiConfiguration)
export const PreApi = new PreApiGen(AuthApiConfiguration)
